import React, { useState } from 'react';
import { useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import './Assessment.css';
import ToastComp from '../../../components/Toast/Toast';
import { Row } from 'react-bootstrap';

function AddAssessmentQuestion(arg) {
  const [show, setShow] = useState(arg.flag);
  const [imageSource, setImageSource] = useState("");
  const [correctAns, setCorrectAns] = useState("");
  const [question, setQuestion] = useState("");
  const [opt, setOpt] = useState({ a: '', b: '', c: '', d: '', e: '' });
  const [showToast, setShowToast] = useState(false);
  const photo = useRef('');
  const photoCord = useRef('');
  const objPhto = useRef('');
  const [objImageSource, setObjImageSource] = useState('');

  const loadImageDummy = async (imgUrl) => {
    fetch(imgUrl)
      .then(response => {
        if (response) {
          return response.blob();
        }
      })
      .then(blob => {
        const file = new File([blob], "dummy_for_fix_11.png", {
          type: 'image/png',
        });
        objPhto.current = file;
      })
      .catch(error => {
        console.error(error);
      });
  }

  if (!objImageSource && arg.type === 1) {
    //load a placeholder image
    if (!objPhto.current) {
      const url = 'placeholderImage.png';
      loadImageDummy(url);
    }

  }



  let grab = false;
  let rect = {
    x0: 0,
    y0: 0,
    x1: 0,
    y1: 0
  }
  const mousedown = (e) => {
    grab = true;
    rect.x0 = e.clientX;
    rect.y0 = e.clientY;
  }

  const mousemove = (e) => {
    if (grab) {
      e.preventDefault();
      rect.x1 = e.clientX;
      rect.y1 = e.clientY;
      showRect();
    }
  }

  const mouseup = (e) => {
    grab = false;
  }

  const showRect = () => {
    var rectDiv = document.getElementById('rect');
    rectDiv.style.display = 'block';
    rectDiv.style.position = 'absolute';
    const a = document.getElementById("img-cont");
    const offset = a.getClientRects()[0];
    const leftOff = offset.left;
    const topOff = offset.top;

    rectDiv.style.left = (rect.x0 - leftOff) + 'px';
    rectDiv.style.top = (rect.y0 - topOff) + 'px';
    rectDiv.style.width = (rect.x1 - rect.x0) + 'px';
    rectDiv.style.height = (rect.y1 - rect.y0) + 'px';
    photoCord.current = [rectDiv.style.left, rectDiv.style.top, rectDiv.style.width, rectDiv.style.height];

  }

  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);

  const loadImage = (event) => {
    photo.current = event.target.files[0];
    setImageSource(URL.createObjectURL(event.target.files[0]));
    setTimeout(() => {
      var div = document.getElementById('img-cont');
      div.addEventListener('mousedown', mousedown);
      div.addEventListener('mouseup', mouseup);
      div.addEventListener('mousemove', mousemove);
    }, 500)
  }

  const loadObjectiveImage = (event) => {
    objPhto.current = event.target.files[0];
    setObjImageSource(URL.createObjectURL(event.target.files[0]));
  }
  //save question
  const saveQuestion = () => {
    setShow(false);
    //Objective
    if (arg.type === 1) {
      const { a, b, c, d, e } = opt;
      const formData = new FormData();
      formData.append("assessmentId", arg.data.id);
      formData.append("questions[0].question", question);
      formData.append("questions[0].image", objPhto.current);
      formData.append("questions[0].option1", a);
      formData.append("questions[0].option2", b);
      formData.append("questions[0].option3", c);
      formData.append("questions[0].option4", d);
      formData.append("questions[0].option5", e);
      formData.append("questions[0].answer", correctAns);
      //end
      arg.saveCb(formData);
    }
    //Intercative
    if (arg.type === 2) {
      const formData = new FormData();
      formData.append("assessmentId", arg.data.id);
      formData.append("questions[0].question", question);
      formData.append("questions[0].image", photo.current);
      formData.append("questions[0].answer", photoCord.current.toString());
      if (photoCord.current === "") {
        setShowToast(true);
        setShow(true);
        return;
      }
      arg.saveCb(formData);
    }
    //Descriptive
    if (arg.type === 3) {
      const req = {
        assessmentId: arg.data.id,
        questions: [
          {
            question
          }
        ]
      };
      arg.saveCb(req);
    }



  }
  return (
    <>
      {showToast ? <ToastComp case='question-error' handler={() => { setShowToast(false); }} /> : ""}
      <Modal show={show} onHide={handleClose} size="lg" backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Add Assessment Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Question</Form.Label>
              <Form.Control
                type="text" value={question} onChange={(e) => { setQuestion(e.target.value) }}
                autoFocus
              />
            </Form.Group>

            <div className='row'>
              {
                arg.type === 2 &&
                <Form.Group
                  className="mb-3 col-md-6"
                >
                  <Form.Label>Upload Image</Form.Label>
                  <Form.Control type="file" className='form-control' accept="image/png, image/jpeg" onChange={(event) => loadImage(event)} />
                  <div id="img-cont">
                    <img id="output" width="500" height="500" src={imageSource} />
                    <div id="rect"></div>
                  </div>
                </Form.Group>
              }

              {
                arg.type === 1 &&
                <>
                  <Row>
                    <Form.Group
                      className="mb-3 col-md-4"
                    >
                      <Form.Label>Upload Image</Form.Label>
                      <Form.Control type="file" className='form-control' accept="image/png, image/jpeg" onChange={(event) => loadObjectiveImage(event)} />
                      <div id="obj-img-cont">
                        <img id="obj-img-output" width="200" height="200" src={objImageSource} />
                      </div>
                    </Form.Group>
                    <Form.Group
                      className="mb-3 col-md-8"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Label>Add Options</Form.Label>
                      <ul className='obj-questions-op'>
                        <li className='mt-1'><input type='text' value={opt.a} onChange={(event) => { setOpt({ ...opt, a: event.target.value }) }} className='form-control'></input><input onChange={() => setCorrectAns('a')} name='ans' value='a' checked={correctAns == "a"} type='radio' className='ml-2' title="Mark here if it is the right option"></input></li>
                        <li className='mt-1'><input type='text' value={opt.b} onChange={(event) => { setOpt({ ...opt, b: event.target.value }) }} className='form-control'></input><input onChange={() => setCorrectAns('b')} name='ans' value='b' checked={correctAns == "b"} type='radio' className='ml-2' title="Mark here if it is the right option"></input></li>
                        <li className='mt-1'><input type='text' value={opt.c} onChange={(event) => { setOpt({ ...opt, c: event.target.value }) }} className='form-control'></input><input onChange={() => setCorrectAns('c')} name='ans' value='c' checked={correctAns == "c"} type='radio' className='ml-2' title="Mark here if it is the right option"></input></li>
                        <li className='mt-1'><input type='text' value={opt.d} onChange={(event) => { setOpt({ ...opt, d: event.target.value }) }} className='form-control'></input><input onChange={() => setCorrectAns('d')} name='ans' value='d' checked={correctAns == "d"} type='radio' className='ml-2' title="Mark here if it is the right option"></input></li>
                        <li className='mt-1'><input type='text' value={opt.e} onChange={(event) => { setOpt({ ...opt, e: event.target.value }) }} className='form-control'></input><input onChange={() => setCorrectAns('e')} name='ans' value='e' checked={correctAns == "e"} type='radio' className='ml-2' title="Mark here if it is the right option"></input></li>
                      </ul>
                    </Form.Group>
                  </Row>
                </>
              }



            </div>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button>
          <Button variant="primary" onClick={saveQuestion}>
            SAVE
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddAssessmentQuestion;

